import { render, staticRenderFns } from "./FaqPresetSection.vue?vue&type=template&id=65cdcab9&scoped=true"
import script from "./FaqPresetSection.vue?vue&type=script&lang=js"
export * from "./FaqPresetSection.vue?vue&type=script&lang=js"
import style0 from "./FaqPresetSection.vue?vue&type=style&index=0&id=65cdcab9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cdcab9",
  null
  
)

export default component.exports